import { MessageCircle, Phone } from "lucide-react";
import { BRAND, telLink, waLink } from "@/lib/brand";
import { TESTIDS } from "@/constants/testIds";

export default function FloatingActions() {
  return (
    <>
      <a
        data-testid={TESTIDS.floatWhatsapp}
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-40 group flex items-center gap-3 bg-[#25D366] hover:bg-[#1FBA57] text-white pl-4 pr-5 py-3.5 shadow-lg hover:shadow-2xl transition-all"
      >
        <MessageCircle size={22} strokeWidth={2} />
        <span className="hidden sm:inline text-sm font-semibold tracking-wide">
          WhatsApp
        </span>
      </a>

      <a
        data-testid={TESTIDS.floatCall}
        href={telLink}
        aria-label={`Call ${BRAND.phone}`}
        className="fixed bottom-24 right-6 z-40 flex items-center gap-3 bg-[#641C24] hover:bg-[#4A151A] text-[#FFFDF8] pl-4 pr-5 py-3.5 shadow-lg hover:shadow-2xl transition-all"
      >
        <Phone size={22} strokeWidth={2} />
        <span className="hidden sm:inline text-sm font-semibold tracking-wide">
          Call Now
        </span>
      </a>
    </>
  );
}
